export const RoboPrecosConfigEntity = {
    id:0
    ,grupo:''
    ,pctminimo:0
    ,pctmaximo:0
    ,pctdiferenca:0
}